// 対象となるホスト
// ここで指定されたホスト以外は、そもそも、対象とならない
const host = 'https://exh2022.tokyocameraclub.com'
// const host = 'localhost'

/**
 * 開催時期判定のutilクラス
 */
class OpeningUtil {
  /**
   * 写真展が開催してるかどうかをチェックする
   * 開催してる場合 true を返す
   * サーバ時間を元に、以下の条件で開催判定を行う
   * ホスト名が https://exh2022.tokyocameraclub.com 以外か、もしくは、
   * 現在時が 2022-09-16 13:00:00 (1663300800) 以降の場合
   * trueを返す
   */
  static async isOpend () {
    // 写真展開催後は以下のコメントアウトを外して強制的にopenモードとする
    // これは、バックエンドは最終的に停止されて getTimestamp APIが使用できなくなるため
    // 2022-09-20 16:44:41に強制的にopen状態になるように修正
    return true;

    // 対象ホスト以外は常にOPEN
    // if (location.href.indexOf(host) < 0) return true
    // // openModeにtrueが設定されていた場合は、自動的にOPENとなる
    // const openMode = localStorage.getItem('openMode');
    // if (openMode == 'true') return true // openModeにtrueが設定されていた場合は、自動的にOPENとなる
    // return await TimestampApi.getTimestamp().then((result) => {
    //   return (result.data.timestamp >= 1663300800) // 1663300800)
    // }).catch((error) => {
    //   console.error(error)
    //   return false
    // })
  }

  /**
   * 写真展が終了してるかどうかをチェックする
   * 終了してる場合 true を返す
   * ローカルPCの時間を基に計算する
   * ローカルPCの時間を基にするのは、終了処理自体がそれほど精度を求めないため
   * 開始は、絶対に見えてしまってはまずいが、終了の判定は終了メッセージ表示等にしか使用しないので問題ない
   * 最終的にはバックエンドのサーバが停止されるので、ローカルPCの時間をいじっても何もできない
   * ホスト名が https://exh2022.tokyocameraclub.com で、かつ、
   * 現在時が 2022-10-22 23:59:59 (1666450799) を過ぎていた場合
   * trueを返す
   */
  static isClosed () {
    // 対象ホスト以外は自動的にcloseさせない
    if (location.href.indexOf(host) < 0) return false
    // closeModeにtrueが設定されていた場合は、自動的にCLOSEとなる
    const closeMode = localStorage.getItem('closeMode');
    if (closeMode == 'true') return true // closeModeにtrueが設定されていた場合は、自動的にCLOSEとなる
    const now = new Date().getTime() / 1000
    return (now > 1666450799)
  }
}

export default OpeningUtil
